import React__default from 'react';
import { ToastContextProviderCore } from '../shared/components/Toast.mjs';
export { useToast } from '../shared/components/Toast.mjs';
import { Typography } from './Typography.mjs';

const alertSx = {
    backgroundColor: (theme)=>theme.styleConfig.container.backgroundColor,
    boxShadow: '0px 5px 10px 0px rgba(0, 0, 0, 0.20)',
    border: '1px solid',
    borderColor: (theme)=>theme.styleConfig.container.borderColor,
    borderRadius: (theme)=>theme.styleConfig.borderRadius
};
const closeIconSx = {
    color: (theme)=>theme.styleConfig.colors.error
};
const errorSx = {
    '&, & p': {
        color: (theme)=>theme.styleConfig.colors.error
    }
};
const errorIconSx = errorSx;
const successSx = {
    '&, & p': {
        color: (theme)=>theme.styleConfig.colors.success
    }
};
const successIconSx = successSx;
const ToastContextProvider = (props)=>{
    return /*#__PURE__*/ React__default.createElement(ToastContextProviderCore, {
        TypographyComponent: Typography,
        ...props,
        alertSx: alertSx,
        closeIconSx: closeIconSx,
        errorIconSx: errorIconSx,
        errorSx: errorSx,
        successIconSx: successIconSx,
        successSx: successSx
    });
};

export { ToastContextProvider };
//# sourceMappingURL=Toast.mjs.map
